import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'component/utils/Select'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

class VersionSelect extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      versions: [],
      error: null,
      loading: false,
    }
  }

  componentDidMount() {
    const { user } = this.props

    this.setState({ loading: true })

    return new Api(user.dsToken)
      .get(API_URL.VERSION_LIST)
      .then((response) => this.onFetchSuccess(response.data))
      .catch((error) => this.onFetchError(error))
  }

  onFetchSuccess(versions) {
    this.setState({ versions, loading: false, error: null })
  }

  onFetchError(error) {
    this.setState({ error, loading: false, versions: [] })
  }

  renderOptions(version, index) {
    return (
      <option key={index} value={version.idVersion}>
        {version.idVersion}
      </option>
    )
  }

  render() {
    const { name, value, onChange, translate } = this.props
    const { versions, loading } = this.state

    const label = loading
      ? translate('loading')
      : translate('version.choose-version')

    return (
      <Select
        id='idVersion'
        name={name}
        label={label}
        value={value}
        onChange={(event) => onChange(event)}
      >
        <option value='' />

        {versions.map(this.renderOptions)}
      </Select>
    )
  }
}

export default VersionSelect
